<template>
  <canvas
    ref="particles"
    class="particles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { ParticlePart as Part } from './ParticlePart'

const DEFAULT_WINDOW_WIDTH_FOR_PARTS_COUNT = 1900

@Component
class BackgroundAnimation extends Vue {
  @Prop({
    type: Array,
    required: true
  }) backgroundEffects

  width = window.innerWidth
  height = window.innerHeight
  isImagesLoaded = false
  ctx = null
  images = []
  parts = []
  partsMax = Math.round(window.innerWidth / DEFAULT_WINDOW_WIDTH_FOR_PARTS_COUNT * 50)
  globalTick = 0
  bigPartsCount = 0
  bigPartsMax

  mounted () {
    this.init()
  }

  init () {
    this.$data.ctx = this.$refs.particles.getContext('2d')
    this.loadImages()
  }

  loadImages () {
    this.$props.backgroundEffects.forEach((effect) => {
      const image = new Image()
      image.src = '/img/effects/' + effect
      this.$data.images.push(image)
      image.onload = () => {
        this.$data.isImagesLoaded++
        if (this.$data.isImagesLoaded === this.$props.backgroundEffects.length) {
          this.createParts()
          this.loop()
        }
      }
    })
  }

  createParts () {
    let i = this.$data.partsMax
    let isBigPart = false
    while (i--) {
      isBigPart = (this.$data.bigPartsMax > this.$data.bigPartsCount)
      if (isBigPart) {
        this.$data.bigPartsCount++
      }
      this.$data.parts.push(new Part({
        ctx: this.$data.ctx,
        cw: this.$data.width,
        ch: this.$data.height,
        isBigPart,
        images: this.$data.images
      }))
    }
  }

  updateParts (resetParts) {
    let i = this.$data.parts.length
    const agruments = {
      images: this.$data.images,
      resetParts
    }

    if (resetParts) {
      agruments.cw = this.$data.width
      agruments.ch = this.$data.height
    }

    while (i--) {
      this.parts[i].update(agruments)
    }
  }

  renderParts () {
    let i = this.$data.parts.length

    while (i--) {
      this.$data.parts[i].render(this.$data.ctx)
    }
  }

  clear () {
    this.$data.ctx.globalCompositeOperation = 'destination-out'
    this.$data.ctx.fillStyle = 'hsla(0, 0%, 0%, 1)'
    this.$data.ctx.fillRect(0, 0, this.$data.width, this.$data.height)
    this.$data.ctx.globalCompositeOperation = 'lighter'
  }

  onResize () {
    const resetParts = true
    this.$data.cw = this.canvas.width = window.innerWidth
    this.$data.ch = this.canvas.height = window.innerHeight

    this.clear()
    this.updateParts(resetParts)
    this.renderParts()
  }

  loop () {
    window.requestAnimationFrame(this.loop.bind(this))
    this.clear()
    this.updateParts()
    this.renderParts()
    this.globalTick++
  }
}

export default BackgroundAnimation
</script>

<style>
.particles {
    position: fixed;
    top: 0;
    left: 0;
    z-index: -1;
}
</style>
